import { createFileRoute } from "@tanstack/react-router";
import { socialImageMeta } from "@/lib/og";
import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";

export const Route = createFileRoute("/tillganglighet")({
  head: () => ({
    meta: [
      { title: "Tillgänglighetsredogörelse — Skolvyn" },
      { name: "description", content: "Vad vi vet om Skolvyns tillgänglighet i dag, vad vi ännu inte har mätt och hur du rapporterar brister." },
      { property: "og:title", content: "Tillgänglighetsredogörelse — Skolvyn" },
      { property: "og:description", content: "Vad vi vet om Skolvyns tillgänglighet i dag och hur du rapporterar brister." },
        ...socialImageMeta({ path: "/tillganglighet" }),
      ],
  }),
  component: Tillganglighet,
});

function Tillganglighet() {
  return (
    <LegalLayout
      eyebrow="Juridik"
      title="Tillgänglighetsredogörelse"
      updated="25 september 2026"
      intro="Skolvyn ska gå att använda för så många som möjligt, oavsett funktionsförmåga. Målet är WCAG 2.1 nivå AA. Här står vad vi vet i dag — och vad vi ännu inte vet."
    >
      <LegalSection id="status" title="Efterlevnadsstatus">
        <p>
          Vi har ännu inte granskat sajten mot{" "}
          <a href="https://www.w3.org/TR/WCAG21/" target="_blank" rel="noreferrer">Web Content Accessibility Guidelines 2.1 nivå AA</a>.
          Därför kan vi inte säga hur väl Skolvyn uppfyller kraven.
        </p>
        <p>
          Den 25 september 2026 gjorde vi en första automatisk kontroll av startsidan, skolsöket, en skolprofil,
          sidan för skolor och skolornas inloggade sidor, i telefon- och datorbredd. En automatisk kontroll hittar
          bara en del av bristerna. Prov med tangentbord, skärmläsare och förstoring har inte gjorts än.
        </p>
      </LegalSection>

      <LegalSection id="brister" title="Kända brister">
        <p>Den automatiska kontrollen hittade två fel, båda på skolprofilerna:</p>
        <ul>
          <li>En lista med uppgifter om skolan är uppbyggd så att en skärmläsare kan läsa den i fel ordning.</li>
          <li>En knapp är mindre än 24 × 24 punkter och kan vara svår att träffa på en pekskärm.</li>
        </ul>
        <p>Listan uppdateras när vi har granskat mer.</p>
      </LegalSection>

      <LegalSection id="kontakt" title="Rapportera brister">
        <p>
          Har du hittat en tillgänglighetsbrist eller behöver innehåll i ett annat format? Hör av dig så svarar vi så snart
          vi kan, oftast inom några dagar.
        </p>
        <ul>
          <li>E-post: <a href="mailto:hej@skolvyn.se">hej@skolvyn.se</a></li>
        </ul>
      </LegalSection>

      <LegalSection id="tillsyn" title="Tillsynsmyndighet">
        <p>
          Om du inte är nöjd med hur vi hanterar din synpunkt kan du vända dig till{" "}
          <a href="https://www.digg.se" target="_blank" rel="noreferrer">Myndigheten för digital förvaltning (DIGG)</a>, som utövar tillsyn över lagen om tillgänglighet till digital offentlig service.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
